// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"_W-z","sponsoredTooltipWrapper":"aX-z","sponsoredTooltip":"bX-z","newCard":"cX-z"};